const questionSelectionActions = {
    types: {
        QUESTION_SELECTION_SET_SELECTION: 'QUESTION_SELECTION_SET_SELECTION',
        QUESTION_SELECTION_RESTORE: 'QUESTION_SELECTION_RESTORE',
        SET_INLINE_CB_SELECTION: 'SET_INLINE_CB_SELECTION',
    },

    setSelection(contentRevisionId, selection) {
        return { type: this.types.QUESTION_SELECTION_SET_SELECTION, contentRevisionId, selection };
    },

    restoreQuestionsSelection(questionSelection) {
        return { type: this.types.QUESTION_SELECTION_RESTORE, questionSelection };
    },

    setCSCBSelection(selectionData) {
        return { type: this.types.SET_INLINE_CB_SELECTION, selectionData };
    },
};

export default questionSelectionActions;
